<template>
	<v-container>
		
		<v-container class="text-center">
			<v-row class="white mx-4 fill-height" style="border-bottom: 4px solid var(--vs-cinza) !important; "
				align="center" justify="center">
				<v-col lg="3" md="3" sm="3" class="pa-0 hidden-sm-and-down fill-height">
					<v-flex class="d-flex align-center justify-center">
						<img :src="empresa.empStrLogoPath" width="80%" height="80%" v-if="empresa" class="pa-4 contain" />
					</v-flex>
				</v-col>

				<v-col lg="9" md="12" sm="12" class="d-flex align-center">
					<v-row no-gutters v-if="destaques">
						<v-row class="fill-height" align="center" justify="center">
							<template v-for="itemDestaque in destaquesRandon()">
								<v-col :key="itemDestaque.id" cols="12" md="6" sm="6" class="py-2 px-2">
									<v-card color="white" width="100%" elevation="0"
										@click="carregarDetalhesItem(itemDestaque, false)"
										style="border-bottom: 3px solid #d32f2f !important;  ">
										<v-row class="fill-height" align="center" style="height: 150px !important;">
											<div style="position: absolute; top: 5px; text-align: left;">
												<img src="../assets/destaque2.png" height="25%" width="25%" />
											</div>
											<v-col cols="5" style="justify-content: center; display: flex;">
												<img :src="itemDestaque.imagem" class="image-fit"
													v-if="itemDestaque.imagem" />
											</v-col>
											<v-col cols="7" class="fill-height flex-column">
												<v-card-text class="pa-0 pr-2">
													<p class="mt-4 caption text-right">
														{{ itemDestaque.fitStrNme }}
													</p>

													<div class="subtitle-2 grey--text"
														v-if="itemDestaque.ancFltDesconto > 0">
														<span class="text-left" style="text-decoration: line-through;">
															{{
																parseFloat(itemDestaque.ancFltPrecoVenda)
																	.toFixed(2)
																	.replace(".", ",") | currency
															}}
														</span>
														<span
															class="body-2 white--text font-weight-regular desconto-destaque float-right">
															<span>
																{{ itemDestaque.ancFltDesconto | porcentagem }}
															</span>
														</span>
													</div>

													<p class="font-weight-black red--text text--darken-4 text-right pt-4"
														style="font-size: 23px">
														{{
															parseFloat(itemDestaque.ancFltPrecoVendaDesconto)
																.toFixed(2)
																.replace(".", ",") | currency
														}}
													</p>
												</v-card-text>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</template>
						</v-row>
					</v-row>
				</v-col>
			</v-row>

			<!-- Deixar componente comentado, aguardando dados do back -->
			<!-- <MenuNavegacao v-on="carregarFiltroCatalogo" /> -->

			<v-row class="mx-4 fill-height" align="center" justify="end">
				<!--Esses 2 campos estão filtrando somente por elementos na tela, por hora não serão apresentados em tela,
				pois é possível fazer o filtro pelo campo pesquisar do cabeçalho-->
				
				<!-- <v-text-field v-model="codigo" label="Código" clearable class="me-4"></v-text-field>
				<v-text-field v-model="nome" label="Nome" clearable class="mx-4"></v-text-field>
				<v-btn @click="filtrarAnuncios" color="primary" class="mx-4">
					Filtrar
				</v-btn> -->
				<!-- Switch para escolher entre card ou tabela -->
				<v-switch v-model="exibirEmTabela" label="Exibir em Tabela" color="primary" class="mx-4" />
			</v-row>
			<v-row class="fill-height mx-4" align="center" justify="center" v-if="exibirEmTabela">
				<template>
					<table class="custom-table">
						<thead>
							<tr>
								<th></th>
								<th>Código</th>
								<th>Nome</th>
								<th>Estoque</th>
								<th>Preço</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="n in anuncios" :key="n.id" @click="carregarDetalhesItem(n, false)">
								<!-- Imagem -->
								<td>
									<img :src="n.imagem" height="80" width="80" class="contain small-image"
										v-if="n.imagem" />
								</td>
								<!-- Código -->
								<td class="text-left">{{ n.fitStrCoditefabricante }}</td>
								<!-- Nome -->
								<td class="text-left">{{ n.fitStrNme }}</td>
								<!-- Quantidade em Estoque -->
								<td class="text-left">
									<div v-if="n.ancIntQtd <= 0">
										Indisponível
									</div>
									<div v-else>
										{{ n.ancIntQtd }}
									</div>
								</td>
								<!-- Preço -->
								<td class="text-right">
									<div v-if="n.ancIntQtd <= 0">-</div>
									<div v-else>
										<span class="original-price" v-if="n.ancFltDesconto > 0">
											{{
												parseFloat(n.ancFltPrecoVenda)
													.toFixed(2)
													.replace(".", ",") | currency
											}}
										</span>
										<span class="discount" v-if="n.ancFltDesconto > 0">
											{{ n.ancFltDesconto | porcentagem }}
										</span>
										<span class="final-price">
											{{
												parseFloat(n.ancFltPrecoVendaDesconto)
													.toFixed(2)
													.replace(".", ",") | currency
											}}
										</span>
									</div>
								</td>
							</tr>
						</tbody>
					</table>
				</template>
			</v-row>
			<v-row class="fill-height" align="center" justify="center" v-else="exibirEmTabela">
				<template v-for="n in anuncios">
					<v-col :key="n.id" cols="50" md="2" sm="5">
						<v-hover v-slot:default="{ hover }">
							<v-card :elevation="hover ? 8 : 4" :class="{ 'on-hover': hover }" color="grey lighten-5"
								@click="carregarDetalhesItem(n, false)">
								<v-row class="fill-height flex-column border-inferior-2px d-block" justify="space-between">
									<v-sheet color="white">
										<figure class="root">
											<img :src="n.imagem" height="150" width="150" class="contain" v-if="n.imagem" />
										</figure>
									</v-sheet>
								</v-row>

								<v-row class="fill-height flex-column" justify="space-between"
									style="height: 210px !important; white-space: nowrap;padding: 6px !important;">
									<div class="mt-2 pl-3 pr-3 mb-0 caption text-left align-start"
										style="max-width: 100%; white-space: normal;">
										{{ n.fitStrCoditefabricante }}
										<br />
										<div class="font-weight-black body-4" style="font-size: 11px">
											{{ n.fitStrNme }}
										</div>
									</div>

									<v-card-text class="pt-0" style="padding: 10px !important;">
										<v-row no-gutters>
											<v-col cols="12" class="pa-0">
												<v-col lg="12" md="12" sm="12" class="pa-0">
													<v-btn v-if="n.ancIntQtd <= 0" depressed outlined
														style="font-size: 10px, border-radius: 1px; height:24px"
														color="var(--vs-vermelho)" @click="cadastrarAviso(n)" dark>
														Avise-me
													</v-btn>

													<div class="caption black--text text-truncate text-left"
														v-if="n.ancIntQtd > 0">
														Qtd. em estoque : {{ n.ancIntQtd }}
													</div>
													<div class="caption black--text text-truncate text-left"
														v-if="n.ancIntQtd <= 0">
														Estoque indisponível
													</div>
												</v-col>

												<v-row no-gutters class="grey--text font-weight-regular">
													<v-col lg="12" md="12" sm="12" class="pa-0 d-flex">
														<span class="text-left pr-4"
															style="text-decoration: line-through; width: 100px">
															{{
																parseFloat(n.ancFltPrecoVenda)
																	.toFixed(2)
																	.replace(".", ",") | currency
															}}
														</span>
														<span class="white--text desconto text-left"
															v-if="n.ancFltDesconto > 0">
															{{ n.ancFltDesconto | porcentagem }}
														</span>
													</v-col>

													<v-col lg="12" md="12" sm="12" class="pa-0">
														<span class="black--text font-weight-black float-right"
															style="font-size: 18px">
															{{
																parseFloat(n.ancFltPrecoVendaDesconto)
																	.toFixed(2)
																	.replace(".", ",") | currency
															}}
														</span>
													</v-col>
												</v-row>
											</v-col>
										</v-row>
									</v-card-text>
								</v-row>
							</v-card>
						</v-hover>
					</v-col>
				</template>
			</v-row>
			<v-row class="fill-height" align="center" justify="center">
				<div class="hidden-md-and-up">
					<v-row no-gutters class>
						<v-col class="12">
							<vs-button color="primary" style="min-width: 300px" @click="carregarMais()">
								<template>Carregar mais ofertas</template>
							</vs-button>
						</v-col>
					</v-row>
				</div>
			</v-row>

			<DetalhesAnuncio :item="item" :dialog="dialog" @dialogfalse="dialog = $event" v-if="item" :comprar="comprar" />
		</v-container>

	</v-container>
</template>

<script>
import { mapGetters } from "vuex";
import DetalhesAnuncio from "@/components/DetalhesAnuncio.vue";
import ImagemAnuncio from "@/components/ImagemAnuncio.vue";
import Alert from "../utils/alert/index";
import Constantes from "../utils/constantes";
import MenuNavegacao from "@/components/MenuNavegacao";
import MenuCatalogoItens from "../components/MenuCatalogoItens.vue";

const sizePage = 24;

export default {
	data() {
		return {
			dialog: false,
			item: null,
			comprar: false,
			bottom: false,
			top: false,
			loading: null,
			align: "center",
			model: null,
			exibirEmTabela: false,
			codigo: "", // Para armazenar o valor do código inserido no input
			nome: "", // Para armazenar o valor do nome inserido no input
		};
	},
	timers: {
		carregarDestaques: { time: 30000, autostart: true, repeat: true },
	},
	methods: {
		carregarDestaques() {
			this.$store.dispatch("anuncio/carregarDestaques", {
				empIntCod: this.$route.params.id,
			});
		},
		destaquesRandon() {
			let destaquesAux = this.destaques.slice(0, 2);
			return destaquesAux;
		},
		handleClickLoading(type) {
			this.loading = this.$vs.loading({
				type,
			});
		},
		hideLoading() {
			this.loading.close();
		},
		carregarDetalhesItem(o, comprar) {
			this.$store.dispatch("anuncio/carregarMensagens", o);
			this.item = o;
			this.$store.dispatch("anuncio/carregarEstoque", this.item);
			this.dialog = true;
			this.comprar = comprar;
			this.$store.dispatch("anuncio/carregarImgSelect", o.imagem);
		},
		carregarMais() {
			// if (
			//   this.qtdAnuncios === sizePage &&
			//   this.codigo === "" &&
			//   this.name === ""
			// ) {
			//   console.log(this.anuncios.length);
			//   console.log(this.anuncios.length % sizePage);
			//   this.carregarAnuncios({
			//     empIntCod: this.$route.params.id,
			//     //ancIntCod: this.anuncios[this.anuncios.length - 1].ancIntCod,
			//     page: Math.round(this.anuncios.length / sizePage),
			//     size: sizePage,
			//   });
			// } else {
			//   Alert.success("", "Todas as ofertas já foram carregadas!");
			// }

			// TODO: rever este trecho de codigo
			console.log(this.anuncios.length);
			console.log(this.anuncios.length % sizePage);
			this.carregarAnuncios({
				empIntCod: this.$route.params.id,
				//ancIntCod: this.anuncios[this.anuncios.length - 1].ancIntCod,
				page: Math.round(this.anuncios.length / sizePage),
				size: sizePage,
			});
		}, carregarFiltroCatalogo(codFabricante) {
			this.carregarAnuncios({
				empIntCod: this.$route.params.id,
				codigoFabricante: codFabricante,
				page: Math.round(this.anuncios.length / sizePage),
				size: sizePage,
			});
		},
		carregarAnuncios(p) {
			console.log("carregarAnuncios", p);
			if (p.texto) {
				this.$store.dispatch("anuncio/procurarAnuncio", p);
			} else {
				this.handleClickLoading("waves");
				this.$store
					.dispatch("anuncio/carregarAnuncios", p)
					.then(() => {
						this.hideLoading();
					})
					.catch(() => {
						this.hideLoading();
					});
			}
		},
		filtrarAnuncios() {
			if (this.codigo === "" && this.nome === "") {
				// Se o campo de pesquisa estiver vazio, retornar todos os anúncios
				this.carregarAnuncios({
					empIntCod: this.$route.params.id,
					page: Math.round(this.anuncios.length / sizePage),
					size: sizePage,
				});
			} else {
				// Filtrar anúncios com base no texto de pesquisa
				const filtro = { codigo: this.codigo, nome: this.nome };
				this.$store.commit("anuncio/setFiltro", filtro);
				this.$store.dispatch("anuncio/filtrarAnuncios");
			}
		},
		bottomVisible() {
			let bottomOfWindow =
				Math.round(
					Math.max(
						window.pageYOffset,
						document.documentElement.scrollTop,
						document.body.scrollTop
					)
				) +
				window.innerHeight ===
				document.documentElement.offsetHeight;

			return bottomOfWindow;
		},
		topVisible() {
			const scrollY = window.scrollY;
			return scrollY === 0;
		},
		cadastrarAviso(item) {
			this.$store.dispatch("anuncio/cadastrarAviso", {
				busuario: this.usuarioLogado,
				anuncio: item,
			});
			this.$emit("dialogfalse", false);
		},
	},
	mounted() {
		if (this.user) {
			const self = this;
			var webSocketUrl = Constantes.URL_SERVIDOR_WS + this.user.cliIntCod;
			this.ws = new WebSocket(webSocketUrl);
			this.ws.onopen = function () {
				console.log("info", "WebSocket connection opened!");
			};
			this.ws.onmessage = function (event) {
				//console.log(" event.data", event.data);
				let tipo = event.data.split(";")[0];
				let count = event.data.split(";")[1];
				if (tipo === "chat") {
					self.$store.dispatch("chat/carregarMensagensNovas", {
						cliIntCod: self.user.cliIntCod,
						chtIntCod: self.ultimamsg,
					});
					self.$store.dispatch("chat/mensagensNova", true);
					self.$store.dispatch("chat/contadorMsg", count);
				} else if (tipo === "carrinho") {
					//console.log("vai atualizar carrinho");
					self.$store.dispatch("pedido/carregarCarrinho", self.user.cliIntCod);
				}
			};
			this.ws.onclose = function () {
				// console.log("warn", "WebSocket closed");
			};
			this.ws.onerror = function (err) {
				// console.log(err);
			};

			this.$store.dispatch("chat/carregarMensagens", this.user.cliIntCod);
			this.$store.dispatch("pedido/carregarCarrinho", this.user.cliIntCod);
			this.$store.dispatch("pedido/carregarPedidos", this.user);

			window.addEventListener("scroll", () => {
				this.bottom = this.bottomVisible();
				this.top = this.topVisible();
			});
			this.$store.dispatch("search/pesquisar", "");
			this.$store.dispatch("anuncio/carregarDestaques", {
				empIntCod: this.$route.params.id,
			});
			this.carregarAnuncios({
				empIntCod: this.$route.params.id,
				page: 0,
				size: sizePage,
				texto: this.$route.query.p,
			});
		}
	},
	watch: {
		bottom(bottom) {
			if (bottom) {
				if (this.load === false) {
					if (this.search !== null && this.search.length > 0) {
						let obj = {};
						obj.texto = this.search;
						obj.empIntCod = this.$route.params.id;
						obj.ancIntCod = this.anuncios[this.anuncios.length - 1].ancIntCod;
						if (this.user) obj.cliIntCod = this.user.cliIntCod;

						this.handleClickLoading("waves");
						this.$store
							.dispatch("anuncio/pesquisar", obj)
							.then(() => {
								this.hideLoading();
							})
							.catch(() => {
								this.hideLoading();
							});
					} else {
						console.log("qtd anuncios no watch: " + this.anuncios.length);
						console.log("page no watch: " + this.anuncios.length / sizePage);
						this.carregarAnuncios({
							empIntCod: this.$route.params.id,
							page: Math.round(this.anuncios.length / sizePage),
							size: sizePage,
							offset: this.qtdAnuncios,
						});
					}
				} else {
					// console.log("ainda ta lendo ...");
				}
			}
		},
	},
	computed: {
		...mapGetters({
			search: "search/search",
			anuncios: "anuncio/anuncios",
			qtdAnuncios: "anuncio/qtdAnuncios",
			empresa: "anuncio/empresa",
			orcamento: "cliente/orcamento",
			debug: "core/debug",
			load: "core/loading",
			user: "cliente/user",
			destaques: "anuncio/destaques",
			ultimamsg: "chat/ultimamsg",
			usuarioLogado: "cliente/usuarioLogado",
		}),
		pesquisar() { },
	},
	components: {
		DetalhesAnuncio,
		ImagemAnuncio,
		MenuNavegacao,
		MenuCatalogoItens
	},
};
</script>

<style scoped>
.v-card {
	transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
	opacity: 0.75;
	transform: scale(0.98);
}

.show-btns {
	color: rgba(255, 255, 255, 1) !important;
}

.desconto {
	padding-right: 5px;
	padding-left: 5px;
	cursor: auto;
	min-height: 18px;
	background: #43a047;
	background-image: initial;
	background-position-x: initial;
	background-position-y: initial;
	background-size: initial;
	background-attachment: initial;
	background-origin: initial;
	background-clip: initial;
	background-color: #43a047;
	border-radius: 5px;
}

.desconto-destaque {
	font-size: 12px;
	padding-right: 5px;
	padding-left: 5px;
	background-color: #43a047;
	border-radius: 5px;
}

.disponivel {
	padding-right: 5px;
	padding-left: 5px;
	cursor: auto;
	min-height: 18px;
	background: #43a047;
	background-image: initial;
	background-position-x: initial;
	background-position-y: initial;
	background-size: initial;
	background-attachment: initial;
	background-origin: initial;
	background-clip: initial;
	background-color: #43a047;
	border-radius: 5px;
}

.indisponivel {
	padding-right: 5px;
	padding-left: 5px;
	cursor: auto;
	min-height: 18px;
	background: #ef6c00;
	background-image: initial;
	background-position-x: initial;
	background-position-y: initial;
	background-size: initial;
	background-attachment: initial;
	background-origin: initial;
	background-clip: initial;
	background-color: #ef6c00;
	border-radius: 5px;
}

.contain {
	object-fit: contain;
}

.esgotado {
	border: 1px solid #414141;
	border-radius: 2px;
	padding: 3px;
	font-size: 12px;
	margin: 0px 2px;
	min-width: 50%;
}

.botoes {
	padding-right: 5px;
	padding-left: 5px;
	width: 60%;
	justify-content: space-around;
	flex: 1;
	flex-direction: row;
	display: flex;
	margin-top: 8px;
}

.image-fit {
	display: block;
	object-fit: contain;
	width: 60%;
	height: 60%;
}

.custom-table {
	width: 100%;
	border-collapse: collapse;
	background-color: #f9f9f9;
}

.custom-table th,
.custom-table td {
	padding: 12px;
	text-align: left;
	border-bottom: 1px solid #e0e0e0;
}

.custom-table th {
	font-weight: bold;
}

.custom-table tbody tr:hover {
	cursor: pointer;
	background-color: #f5f5f5;
}

.contain {
	object-fit: contain;
}

.stock-status {
	padding: 4px 8px;
	font-size: 12px;
	border-radius: 4px;
	color: #fff;
}

.in-stock {
	background-color: #43a047;
}

.out-of-stock {
	background-color: #ef6c00;
}

.original-price {
	text-decoration: line-through;
	margin-right: 6px;
	font-size: 14px;
	color: #9e9e9e;
}

.discount {
	background-color: #43a047;
	padding: 2px 4px;
	border-radius: 4px;
	color: #fff;
	font-size: 12px;
	margin-right: 6px;
}

.final-price {
	font-size: 18px;
	font-weight: bold;
	color: #000;
}

.custom-table th,
.custom-table td {
	border-bottom: none;
	border-top: none;
}

.custom-table td {
	border-bottom: 1px solid #e0e0e0;
}

.custom-table th:last-child,
.custom-table td:last-child {
	border-right: none;
}

.custom-table th,
.custom-table td {
	padding: 8px 12px;
}

.small-image {
	width: 32px;
	height: 32px;
	object-fit: cover;
	border-radius: 0;
}

.filter-container {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: 20px auto;
	max-width: 1000px;
}

.input-container {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
}

.v-btn {
	margin-top: 8px;
}</style>
